import { ScheduledActions } from '@play-co/replicant';

export type ScheduledActionHandlers<
  TScheduledActions extends ScheduledActions
> = {
  [K in keyof TScheduledActions]: TScheduledActions[K]['action'];
};

export const extractScheduledActionHandlers = <
  TScheduledActions extends ScheduledActions
>(
  actions: TScheduledActions,
) =>
  Object.entries(actions).reduce(
    (actions, [name, { action }]) => ({
      ...actions,
      [name]: action,
    }),
    {} as ScheduledActionHandlers<TScheduledActions>,
  );

export const defineScheduledActions = <
  T extends (actions: any) => ScheduledActions
>(
  factory: T,
  actions: T extends (actions: infer P) => ScheduledActions ? P : never,
) => actions;
